import {isFundraisingMode} from '~/selectors/LabModeSelectors';
import {
  SIMPLE_PRICING_FLAG,
  UPLOAD_ONE_COLOR_FLAG,
  UPLOAD_AUTO_SIZING_FLAG,
  WAYS_TO_ORDER_FLAG,
  signaler
} from '~/adapters/signaler/signalerFeatureFlags';
import {__DEVELOPMENT__} from '~/utils/env';

export const getSignalValueSelector = flag => signaler.featureFlag(flag);

export const getSignalFlagSelector = (flag, testValue = 'test') =>
  signaler.featureFlag(flag) === testValue;

export const getSignalFlagSelectorRegex = (flag, testValue = 'test') =>
  signaler.featureFlag(flag) && signaler.featureFlag(flag).match(testValue);

export const isCartMode = () => false;

export const defaultBlankValue = () => {
  return getSignalValueSelector('defaultBlank_v9');
};

export const isStreamlinedMobileMode = state =>
  state.config.get('streamlinedMobileMode');

export const streamlinedMobileIntent = state =>
  state.config.get('streamlinedMobileIntent');

export const isSleeveDecoEligible = state => {
  if (state.mode && isFundraisingMode(state)) {
    return false;
  }
  if (state.config.get('sleevePrintOverride') !== null) {
    return state.config.get('sleevePrintOverride');
  }
  return false;
};

export const isMultiItemEligible = () => true;

export const isOosEligible = () => true;

export const uploadColorRemoval = () =>
  getSignalFlagSelector('uploadColorRemoval');

export const isLabExitWarningEligible = state =>
  !__DEVELOPMENT__ && state.config.get('exitWarningEligible');

export const cartCookie = () => ({
  email: '',
  postalCode: '',
  orderItemCount: 0
});

export const cartCookiePostalCode = state => cartCookie(state).postalCode;
export const cartCookieEmail = state => cartCookie(state).email;

export const clipartRecoloringOverride = state =>
  state.config.get('clipartRecoloringOverride');

export const designLastSavedSession = state => state.config.get('lastSaved');

export const autoFitTextFlag = 'autoFitText';
export const isAutoFitTextEnabled = () =>
  getSignalFlagSelectorRegex(autoFitTextFlag);
export const autoFitTextFlagValue = () =>
  getSignalValueSelector(autoFitTextFlag);

export const collaborationFlag = 'collaboration_v5';
export const collaborationTestEnabled = () =>
  getSignalFlagSelector(collaborationFlag);

export const singlesContentAlertEnabled = () => true;

export const singlesPricingMessageFlag = 'singlesPricingMessage_v4';
export const singlesPricingMessageEnabled = () =>
  getSignalFlagSelector(singlesPricingMessageFlag);

export const uploadResFlag = 'uploadResolution_v3';
export const uploadResTestValue = () => getSignalValueSelector(uploadResFlag);
export const uploadResTestEnabled = () => getSignalFlagSelector(uploadResFlag);

// optimize WTO test
export const wtoTest = WAYS_TO_ORDER_FLAG;
export const wtoTestValue = () => getSignalValueSelector(wtoTest);
export const wtoTestEnabled = () => {
  return getSignalFlagSelector(wtoTest);
};

export const decorationOverrides = 'decoration_overrides_v1';
export const decorationOverridesEnabled = () =>
  getSignalFlagSelector(decorationOverrides);

export const getSimplePricingTestValue = () =>
  getSignalValueSelector(SIMPLE_PRICING_FLAG);
export const simplePricingTestEnabled = () =>
  getSignalFlagSelector(SIMPLE_PRICING_FLAG);

export const isUploadOneColorEnabled = () =>
  getSignalFlagSelector(UPLOAD_ONE_COLOR_FLAG);

export const isUploadAutoSizingEnabled = () =>
  getSignalFlagSelector(UPLOAD_AUTO_SIZING_FLAG);
